var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_c('p',[_vm._v(" Start by entering a Tibetan word or a segment of text inside the white textarea on the left ... ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }